import { Component, ElementRef, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { InfoSpedizioniVini } from '../../_classi/InfoSpedizioniVini';
import { VinoItem } from '../../_classi/VinoItem';
import { CantinaService } from '../../_servizi/cantina.service';
import { MessageServiceService } from '../../_servizi/message-service.service';
import { PacchettoItem } from 'src/app/_classi/PacchettoItem';

function TRANSLATE(str: string) {
  return str;
}
@Component({
  selector: 'app-vini-vendibili-layout-base',
  templateUrl: './vini-vendibili-layout-base.component.html',
  styleUrls: ['./vini-vendibili-layout-base.component.css']
})
export class ViniVendibiliLayoutBaseComponent implements OnInit, OnChanges {

  observer!: ResizeObserver;

  checkAbilitato = false;
  abilitato = false;
  nonabilitatoMsg = '';

  @Input() codiceForm: any;
  @Input() linguaCorrente: string;
  @Input() vini: VinoItem[];
  @Input() pacchetti: PacchettoItem[];

  @Output() filtraPacchetti = new EventEmitter<any>();
  @Output() selezionaVino = new EventEmitter<any>();


  vinoSelezionato: VinoItem = null;
  viniArray: VinoItem[] = [];
  viniFiltered: VinoItem[] = [];

  filtroProdotto = null;
  prodotti = [
    { id: '0', label_traduzione: TRANSLATE('base.tutti'), label: 'Tutti', visible: true },
    { id: '6', label_traduzione: TRANSLATE('base.winebox'), label: 'WineBox', visible: true },
    { id: '1', label_traduzione: TRANSLATE('base.rosso'), label: 'Rosso', visible: true },
    { id: '2', label_traduzione: TRANSLATE('base.bianco'), label: 'Bianco', visible: true },
    { id: '3', label_traduzione: TRANSLATE('base.rosato'), label: 'Rosato', visible: true },
    { id: '4', label_traduzione: TRANSLATE('base.spumante'), label: 'Spumante', visible: true },
    { id: '5', label_traduzione: TRANSLATE('base.altri'), label: 'Altri prodotti', visible: true },
  ];
  prodottiVisibili = [];

  infoSpedizioni: InfoSpedizioniVini;

  constructor(
    private messageService: MessageServiceService,
    private cantinaService: CantinaService,
    private host: ElementRef,
    private zone: NgZone,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.viniFiltered = this.vini;
    let i = 0;
    for (const prodotto of this.prodotti) {
      if (i != 0) {
        if (prodotto.label !== 'WineBox') {
          prodotto.visible = this.vini.filter(
            vino => vino.colore_id && vino.colore_id === prodotto.id
          ).length > 0 ? true : false;
        }
      }
      i++;
    }
    this.prodottiVisibili = this.prodotti.filter(prodotto => prodotto.visible);
    this.infoSpedizioni = this.cantinaService.getInfoSpedizioniSconti();

  }



  ngOnInit(): void {
    this.filtroProdotto = this.prodottiVisibili[0].label;
  }

  apriDettaglioVino(idx, vino) {
    this.cantinaService.setIdxViSelezionato(null);
    this.viniArray = [];
    this.vinoSelezionato = vino;
    this.viniArray.push(this.vinoSelezionato);
    this.cantinaService.setIdxViSelezionato(idx);
    this.scrollToElementById('top__page');
    this.selezionaVino.emit(true);
  }

  scrollToElementById(id) {
    window.onload = function () {
      const iframe = document.getElementById('iframeCwVini') as HTMLIFrameElement;
      if (iframe) {
        iframe.onload = function () {
          setTimeout(() => {
            const element = iframe.contentDocument?.getElementById(id);
            if (element) {
              const topPos = element.getBoundingClientRect().top + (iframe.contentWindow?.pageYOffset || 0);
              smoothScrollTo(iframe.contentWindow, topPos);
            }
          }, 100);
        };
      }
    }
  }

  tornaIndietro() {
    const idx = this.cantinaService.getIdxViSelezionato();
    if (idx) {
      this.scrollTO('vino__' + idx);
    }
    this.cantinaService.setIdxViSelezionato(null);
    this.vinoSelezionato = null;
    this.viniArray = [];
  }

  scrollTO(target) {
    setTimeout(() => {
      document.getElementById(target).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }, 100);
  }

  filtra(filtro) {
    switch (filtro) {
      case 'Tutti':
        this.viniFiltered = this.vini;
        break;
      case 'WineBox':
        this.viniFiltered = [];
        break;
      default:
        this.viniFiltered = this.vini.filter(vino => vino.colore_id === filtro || filtro === '0');
    }
    this.filtraPacchetti.emit(filtro);
  }

  percentualeSconto(vino: VinoItem) {
    const first = vino.prezzo;
    const last = vino.choosePrezzoScontato(vino);
    return last * 100 / first - 100;
  }
}

function smoothScrollTo(targetWindow: Window | null, targetPos: number) {
  if (!targetWindow) return;

  const duration = 600;
  const start = targetWindow.scrollY;
  const change = targetPos - start;
  let currentTime = 0;
  const increment = 20;

  function animateScroll() {
    currentTime += increment;
    const val = easeInOutQuad(currentTime, start, change, duration);
    targetWindow.scrollTo(0, val);
    if (currentTime < duration) {
      requestAnimationFrame(animateScroll);
    }
  }

  animateScroll();
}

function easeInOutQuad(t: number, b: number, c: number, d: number) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
}
